const tables = {
  // 07 - ТОВ "ПРIМАРIУС"
  '07p': {
    a95e: {
      type: 'A-95 Energy',
      typeId: 'a95e',
      tankId: 1,
      tube: 40,
      maxHeight: 279,
      maxCapacity: 26572,
      minCapacity: 1325,
      capacityTable: [
        31, 50, 74, 102, 133, 167, 204, 243, 284, 328, 374, 421, 471, 522, 575,
        629, 686, 743, 802, 863, 925, 989, 1053, 1119, 1187, 1255, 1325, 1396,
        1468, 1541, 1615, 1691, 1767, 1845, 1923, 2003, 2083, 2165, 2247, 2330,
        2414, 2499, 2585, 2672, 2760, 2848, 2938, 3028, 3119, 3210, 3303, 3396,
        3490, 3584, 3680, 3776, 3873, 3970, 4068, 4167, 4266, 4366, 4467, 4568,
        4640, 4773, 4876, 4980, 5084, 5189, 5294, 5400, 5506, 5613, 5721, 5829,
        5937, 6046, 6156, 6266, 6376, 6487, 6598, 6710, 6822, 6934, 7048, 7161,
        7275, 7389, 7504, 7618, 7734, 7850, 7966, 8082, 8199, 8316, 8433, 8551,
        8669, 8787, 8906, 9025, 9144, 9263, 9383, 9503, 9623, 9744, 9864, 9985,
        10106, 10228, 10349, 10471, 10593, 10715, 10837, 10960, 11083, 11205,
        11328, 11451, 11574, 11698, 11821, 11945, 12068, 12192, 12316, 12440,
        12564, 12688, 12812, 12936, 13060, 13184, 13309, 13433, 13558, 13683,
        13806, 13930, 14054, 14178, 14302, 14426, 14550, 14674, 14797, 14921,
        15044, 15168, 15291, 15414, 15537, 15659, 15782, 15904, 16027, 16149,
        16271, 16392, 16514, 16635, 16756, 16877, 16997, 17118, 17238, 17357,
        17477, 17596, 17715, 17834, 17952, 18070, 18188, 18306, 18423, 18540,
        18656, 18772, 18888, 19003, 19118, 19233, 19347, 19461, 19574, 19688,
        19800, 19912, 20024, 20135, 20246, 20357, 20466, 20576, 20685, 20793,
        20901, 21009, 21116, 21222, 21328, 21433, 21538, 21642, 21746, 21849,
        21951, 22053, 22154, 22254, 22354, 22454, 22552, 22650, 22748, 22844,
        22940, 23035, 23130, 23223, 23316, 23408, 23500, 23591, 23680, 23769,
        23858, 23945, 24031, 24117, 24202, 24286, 24369, 24451, 24532, 24612,
        24691, 24769, 24846, 24922, 24997, 25071, 25144, 25215, 25285, 25355,
        25423, 25489, 25555, 25619, 25682, 25743, 25803, 25862, 25919, 25974,
        26028, 26080, 26130, 26179, 26225, 26270, 26313, 26353, 26391, 26426,
        26459, 26488, 26514, 26536, 26552, 26563, 26569, 26572,
      ],
    },

    a92: {
      type: 'А-92',
      tankId: 2,
      tube: 34,
      maxHeight: 281,
      maxCapacity: 26763,
      minCapacity: 1461,
      capacityTable: [
        15, 27, 44, 66, 93, 123, 157, 193, 232, 273, 316, 362, 409, 459, 510,
        563, 618, 674, 732, 791, 852, 915, 978, 1043, 1110, 1178, 1247, 1317,
        1388, 1461, 1534, 1609, 1685, 1762, 1840, 1919, 1999, 2080, 2162, 2246,
        2329, 2414, 2500, 2587, 2674, 2763, 2852, 2942, 3033, 3125, 3217, 3311,
        3405, 3499, 3595, 3691, 3788, 3886, 3984, 4083, 4183, 4283, 4385, 4486,
        4588, 4691, 4795, 4899, 5004, 5109, 5215, 5321, 5428, 5536, 5644, 5752,
        5861, 5971, 6081, 6192, 6303, 6414, 6526, 6639, 6752, 6865, 6979, 7093,
        7207, 7322, 7438, 7554, 7670, 7786, 7903, 8021, 8138, 8256, 8375, 8493,
        8612, 8731, 8851, 8971, 9091, 9212, 9332, 9453, 9575, 9696, 9818, 9940,
        10062, 10184, 10307, 10430, 10553, 10676, 10800, 10923, 11047, 11171,
        11295, 11419, 11544, 11668, 11793, 11918, 12043, 12168, 12293, 12418,
        12544, 12669, 12794, 12919, 13045, 13171, 13297, 13424, 13548, 13674,
        13798, 13924, 14049, 14174, 14300, 14425, 14550, 14675, 14800, 14925,
        15050, 15175, 15299, 15423, 15548, 15672, 15796, 15920, 16043, 16167,
        16290, 16413, 16536, 16658, 16781, 16903, 17025, 17146, 17268, 17389,
        17510, 17630, 17751, 17871, 17990, 18110, 18229, 18348, 18466, 18585,
        18702, 18820, 18937, 19054, 19170, 19286, 19402, 19517, 19632, 19746,
        19860, 19974, 20087, 20199, 20312, 20423, 20535, 20645, 20756, 20866,
        20975, 21084, 21192, 21300, 21407, 21514, 21620, 21725, 21830, 21935,
        22038, 22142, 22244, 22346, 22447, 22548, 22648, 22747, 22846, 22944,
        23041, 23138, 23234, 23329, 23423, 23517, 23609, 23701, 23793, 23883,
        23973, 24061, 24149, 24236, 24322, 24408, 24492, 24575, 24658, 24739,
        24820, 24899, 24977, 25055, 25131, 25206, 25280, 25353, 25425, 25496,
        25565, 25633, 25700, 25765, 25829, 25892, 25954, 26013, 26072, 26129,
        26184, 26237, 26289, 26339, 26387, 26433, 26477, 26519, 26558, 26595,
        26629, 26660, 26688, 26711, 26730, 26744, 26753, 26759, 26762, 26763,
      ],
    },

    a95: {
      type: 'А-95',
      tankId: 3,
      tube: 39,
      maxHeight: 275,
      maxCapacity: 26519,
      minCapacity: 1432,
      capacityTable: [
        109, 141, 176, 213, 253, 296, 340, 387, 436, 486, 539, 593, 649, 706,
        765, 826, 888, 951, 1016, 1082, 1149, 1218, 1288, 1359, 1432, 1505,
        1580, 1656, 1732, 1810, 1889, 1969, 2050, 2133, 2216, 2299, 2384, 2470,
        2557, 2644, 2733, 2822, 2912, 3003, 3095, 3188, 3281, 3375, 3470, 3566,
        3662, 3759, 3857, 3955, 4055, 4154, 4255, 4356, 4458, 4560, 4663, 4767,
        4871, 4976, 5082, 5188, 5294, 5401, 5509, 5617, 5726, 5835, 5945, 6055,
        6166, 6277, 6389, 6501, 6613, 6726, 6840, 6954, 7068, 7183, 7298, 7414,
        7530, 7646, 7763, 7880, 7997, 8115, 8233, 8351, 8470, 8589, 8709, 8828,
        8948, 9069, 9189, 9310, 9431, 9552, 9674, 9796, 9918, 10040, 10163,
        10285, 10408, 10531, 10655, 10778, 10902, 11026, 11150, 11274, 11398,
        11523, 11647, 11772, 11897, 12022, 12147, 12272, 12397, 12522, 12647,
        12773, 12898, 13023, 13149, 13274, 13400, 13526, 13651, 13776, 13902,
        14027, 14152, 14278, 14403, 14528, 14653, 14778, 14903, 15027, 15152,
        15276, 15401, 15525, 15649, 15773, 15897, 16020, 16144, 16267, 16390,
        16512, 16635, 16757, 16879, 17001, 17122, 17244, 17365, 17486, 17606,
        17726, 17846, 17966, 18085, 18204, 18322, 18441, 18559, 18676, 18793,
        18910, 19027, 19143, 19259, 19374, 19489, 19603, 19717, 19831, 19944,
        20057, 20169, 20281, 20392, 20503, 20613, 20723, 20832, 20941, 21049,
        21157, 21264, 21371, 21477, 21582, 21687, 21791, 21895, 21998, 22101,
        22202, 22303, 22404, 22504, 22603, 22701, 22799, 22896, 22992, 23088,
        23183, 23277, 23370, 23462, 23554, 23645, 23735, 23824, 23912, 23999,
        24086, 24171, 24256, 24340, 24422, 24504, 24585, 24665, 24743, 24821,
        24898, 24973, 25047, 25120, 25192, 25263, 25333, 25401, 25468, 25533,
        25598, 25661, 25722, 25782, 25840, 25897, 25952, 26005, 26057, 26107,
        26155, 26201, 26244, 26286, 26325, 26361, 26395, 26425, 26452, 26475,
        26492, 26501, 26508, 26513, 26516, 26518, 26519,
      ],
    },

    diesel: {
      type: 'ДТ',
      tankId: 4,
      tube: 44,
      maxHeight: 281,
      maxCapacity: 26852,
      minCapacity: 1763,
      capacityTable: [
        0, 0, 4, 17, 37, 61, 89, 120, 154, 191, 230, 271, 315, 361, 408, 458,
        509, 562, 617, 674, 732, 791, 852, 915, 979, 1044, 1110, 1178, 1247,
        1317, 1389, 1461, 1535, 1610, 1686, 1763, 1841, 1920, 2000, 2081, 2164,
        2247, 2331, 2416, 2501, 2588, 2676, 2764, 2853, 2944, 3034, 3126, 3219,
        3312, 3406, 3501, 3596, 3693, 3790, 3887, 3986, 4085, 4185, 4285, 4386,
        4488, 4590, 4693, 4796, 4900, 5005, 5110, 5216, 5323, 5430, 5537, 5645,
        5754, 5863, 5972, 6082, 6193, 6304, 6416, 6528, 6640, 6753, 6866, 6980,
        7094, 7209, 7324, 7439, 7555, 7671, 7787, 7904, 8022, 8139, 8257, 8375,
        8494, 8613, 8732, 8852, 8972, 9092, 9212, 9333, 9454, 9575, 9696, 9818,
        9940, 10062, 10185, 10307, 10430, 10553, 10676, 10800, 10923, 11047,
        11171, 11295, 11419, 11544, 11668, 11793, 11917, 12042, 12167, 12292,
        12417, 12542, 12668, 12793, 12918, 13044, 13169, 13295, 13420, 13545,
        13671, 13796, 13922, 14047, 14172, 14297, 14423, 14548, 14673, 14798,
        14922, 15047, 15172, 15296, 15421, 15545, 15669, 15793, 15917, 16040,
        16164, 16287, 16410, 16533, 16655, 16778, 16900, 17022, 17144, 17265,
        17387, 17508, 17628, 17749, 17869, 17989, 18108, 18228, 18347, 18465,
        18583, 18701, 18819, 18936, 19053, 19170, 19286, 19402, 19517, 19632,
        19747, 19861, 19975, 20088, 20201, 20314, 20426, 20537, 20648, 20759,
        20869, 20979, 21088, 21196, 21304, 21412, 21519, 21626, 21731, 21837,
        21942, 22046, 22149, 22252, 22355, 22456, 22557, 22658, 22758, 22857,
        22955, 23053, 23150, 23246, 23342, 23437, 23531, 23624, 23717, 23809,
        23900, 23990, 24079, 24168, 24256, 24342, 24428, 24513, 24597, 24681,
        24763, 24844, 24924, 25003, 25082, 25159, 25235, 25310, 25384, 25457,
        25528, 25598, 25668, 25736, 25802, 25867, 25931, 25994, 26055, 26115,
        26173, 26230, 26285, 26338, 26389, 26439, 26487, 26533, 26577, 26619,
        26658, 26695, 26729, 26761, 26789, 26813, 26833, 26848, 26852,
      ],
    },
  },

  // 16 - ТОВ "ПРIМАРIУС" - Closed
  // '16p': {
  //   a95e: {
  //     type: 'A-95 Energy',
  //     typeId: 'a95e',
  //     tankId: 1,
  //     tube: 101,
  //     maxHeight: 238,
  //     maxCapacity: 21000,
  //     minCapacity: 502,
  //     capacityTable: [
  //       0, 22, 44, 66, 88, 110, 145, 185, 225, 265, 305, 349, 400, 451, 502,
  //       553, 606, 665, 725, 785, 845, 904, 970, 1037, 1104, 1171, 1238, 1308,
  //       1381, 1455, 1528, 1601, 1675, 1754, 1832, 1911, 1989, 2068, 2151, 2234,
  //       2317, 2400, 2484, 2570, 2657, 2745, 2832, 2919, 3008, 3099, 3190, 3282,
  //       3373, 3464, 3559, 3653, 3747, 3842, 3936, 4033, 4131, 4228, 4325, 4423,
  //       4520, 4616, 4712, 4808, 4905, 5002, 5101, 5201, 5300, 5400, 5499, 5601,
  //       5703, 5805, 5907, 6009, 6112, 6216, 6320, 6423, 6527, 6632, 6738, 6843,
  //       6949, 7055, 7161, 7268, 7375, 7482, 7590, 7697, 7805, 7914, 8023, 8132,
  //       8241, 8350, 8460, 8571, 8681, 8791, 8901, 9012, 9122, 9233, 9343, 9454,
  //       9565, 9677, 9789, 9901, 10013, 10124, 10236, 10348, 10460, 10571, 10683,
  //       10795, 10907, 11018, 11130, 11142, 11354, 11466, 11579, 11691, 11803,
  //       11914, 12026, 12137, 12248, 12359, 12470, 12581, 12692, 12802, 12913,
  //       13024, 13133, 13243, 13352, 13462, 13572, 13680, 13789, 13897, 14005,
  //       14114, 14221, 14328, 14436, 14543, 14650, 14757, 14862, 14968, 15073,
  //       15179, 15284, 15387, 15490, 15594, 15697, 15800, 15902, 16003, 16105,
  //       16206, 16307, 16407, 16506, 16605, 16704, 16803, 16902, 17000, 17097,
  //       17195, 17293, 17390, 17485, 17579, 17673, 17767, 17861, 17953, 18043,
  //       18134, 18224, 18315, 18404, 18490, 18577, 18663, 18750, 18836, 18920,
  //       19003, 19086, 19170, 19253, 19333, 19411, 19489, 19568, 19646, 19723,
  //       19798, 19873, 19948, 20023, 20096, 20155, 20215, 20275, 20335, 20394,
  //       20447, 20498, 20549, 20600, 20651, 20696, 20735, 20775, 20815, 20855,
  //       20890, 20912, 20934, 20956, 20978, 21000,
  //     ],
  //   },

  //   a92: {
  //     type: 'А-92',
  //     tankId: 2,
  //     tube: 114,
  //     maxHeight: 238,
  //     maxCapacity: 21000,
  //     minCapacity: 511,
  //     capacityTable: [
  //       0, 22, 45, 67, 90, 112, 147, 188, 228, 269, 310, 355, 407, 459, 511,
  //       563, 616, 676, 737, 798, 859, 919, 986, 1064, 1123, 1191, 1259, 1330,
  //       1405, 1479, 1553, 1628, 1703, 1783, 1863, 1943, 2023, 2102, 2187, 2271,
  //       2356, 2441, 2525, 2613, 2702, 2790, 2879, 2968, 3059, 3151, 3244, 3336,
  //       3429, 3522, 3618, 3714, 3810, 3906, 4002, 4101, 4200, 4299, 4398, 4497,
  //       4594, 4691, 4787, 4884, 4980, 5077, 5177, 5276, 5376, 5475, 5575, 5676,
  //       5778, 5879, 5981, 6082, 6185, 6289, 6393, 6497, 6601, 6705, 6811, 6916,
  //       7022, 7128, 7233, 7341, 7449, 7556, 7664, 7771, 7880, 7989, 8097, 8206,
  //       8315, 8424, 8534, 8643, 8753, 8862, 8972, 9083, 9194, 9305, 9415, 9526,
  //       9637, 9749, 9861, 9972, 10084, 10195, 10307, 10419, 10530, 10642, 10754,
  //       10865, 10977, 11089, 11201, 11313, 11425, 11537, 11649, 11761, 11873,
  //       11984, 12096, 12207, 12318, 12430, 12541, 12651, 12762, 12872, 12983,
  //       13093, 13203, 13312, 13422, 13532, 13641, 13750, 13859, 13968, 14077,
  //       14185, 14294, 14401, 14509, 14616, 14724, 14831, 14936, 15042, 15148,
  //       15253, 15359, 15463, 15567, 15671, 15775, 15879, 15982, 16084, 16186,
  //       16288, 16390, 16491, 16591, 16691, 16791, 16891, 16990, 17088, 17186,
  //       17283, 17381, 17479, 17572, 17664, 17757, 17849, 17942, 18032, 18121,
  //       18210, 18298, 18387, 18475, 18559, 18644, 18729, 18813, 18898, 18977,
  //       19057, 19137, 19217, 19297, 19372, 19447, 19521, 19595, 19670, 19741,
  //       19809, 19877, 19946, 20014, 20081, 20141, 20202, 20263, 20324, 20384,
  //       20437, 20489, 20541, 20593, 20645, 20690, 20731, 20772, 20812, 20853,
  //       20888, 20910, 20933, 20955, 20978, 21000,
  //     ],
  //   },

  //   a95: {
  //     type: 'А-95',
  //     tankId: 3,
  //     tube: 128,
  //     maxHeight: 238,
  //     maxCapacity: 21000,
  //     minCapacity: 511,
  //     capacityTable: [
  //       0, 22, 45, 67, 90, 112, 148, 188, 229, 269, 310, 355, 407, 459, 511,
  //       563, 616, 677, 738, 799, 859, 920, 987, 1055, 1123, 1191, 1260, 1331,
  //       1406, 1480, 1554, 1629, 1705, 1785, 1864, 1944, 2024, 2104, 2188, 2273,
  //       2358, 2442, 2527, 2615, 2704, 2793, 2881, 2970, 3061, 3154, 3246, 3339,
  //       3432, 3525, 3621, 3717, 3813, 3909, 4005, 4104, 4203, 4302, 4401, 4500,
  //       4598, 4694, 4790, 4886, 4983, 5079, 5178, 5276, 5375, 5473, 5572, 5672,
  //       5773, 5874, 5975, 6075, 6178, 6281, 6384, 6487, 6590, 6694, 6800, 6907,
  //       7013, 7119, 7226, 7332, 7439, 7546, 7653, 7759, 7868, 7977, 8086, 8195,
  //       8304, 8412, 8521, 8630, 8738, 8847, 8956, 9066, 9176, 9287, 9397, 9507,
  //       9618, 9728, 9839, 9950, 10060, 10171, 10282, 10392, 10503, 10614, 10725,
  //       10837, 10949, 11062, 11174, 11286, 11398, 11509, 11621, 11733, 11845,
  //       11956, 12067, 12178, 12289, 12400, 12511, 12621, 12731, 12841, 12951,
  //       13061, 13170, 13280, 13389, 13498, 13608, 13716, 13824, 13933, 14041,
  //       14149, 14256, 14363, 14469, 14576, 14682, 14789, 14895, 15001, 15108,
  //       15214, 15321, 15423, 15526, 15628, 15731, 15833, 15935, 16037, 16139,
  //       16241, 16343, 16444, 16543, 16643, 16742, 16841, 16940, 17036, 17132,
  //       17228, 17324, 17421, 17517, 17613, 17709, 17805, 17902, 17995, 18087,
  //       18179, 18271, 18362, 18453, 18542, 18630, 18719, 18808, 18896, 18976,
  //       19056, 19136, 19215, 19295, 19371, 19446, 19520, 19594, 19669, 19740,
  //       19809, 19877, 19945, 20013, 20080, 20141, 20201, 20262, 20323, 20384,
  //       20437, 20489, 20541, 20593, 20645, 20690, 20731, 20771, 20812, 20853,
  //       20888, 20910, 20933, 20955, 20978, 21000,
  //     ],
  //   },

  //   diesel: {
  //     type: 'ДТ',
  //     tankId: 4,
  //     tube: 142,
  //     maxHeight: 238,
  //     maxCapacity: 21000,
  //     minCapacity: 508,
  //     capacityTable: [
  //       0, 22, 45, 67, 89, 112, 147, 187, 227, 268, 308, 353, 405, 457, 508,
  //       560, 613, 673, 734, 794, 855, 915, 982, 1050, 1118, 1185, 1253, 1324,
  //       1398, 1472, 1546, 1620, 1696, 1775, 1855, 1934, 2014, 2093, 2177, 2262,
  //       2346, 2430, 2514, 2601, 2690, 2778, 2867, 2955, 3045, 3137, 3230, 3322,
  //       3414, 3507, 3602, 3698, 3794, 3889, 3985, 4079, 4172, 4266, 4360, 4453,
  //       4548, 4645, 4742, 4838, 4935, 5032, 5132, 5231, 5331, 5430, 5530, 5631,
  //       5732, 5834, 5935, 6036, 6139, 6242, 6346, 6449, 6552, 6656, 6761, 6867,
  //       6972, 7077, 7183, 7290, 7397, 7504, 7611, 7718, 7827, 7935, 8044, 8153,
  //       8261, 8371, 8480, 8589, 8699, 8808, 8917, 9028, 9138, 9248, 9358, 9469,
  //       9579, 9690, 9801, 9912, 10023, 10134, 10246, 10358, 10470, 10581, 10693,
  //       10805, 10917, 11029, 11141, 11252, 11364, 11476, 11588, 11700, 11812,
  //       11923, 12034, 12146, 12257, 12368, 12479, 12590, 12700, 12811, 12922,
  //       13032, 13142, 13251, 13360, 13470, 13579, 13688, 13797, 13906, 14015,
  //       14124, 14232, 14339, 14447, 14554, 14661, 14768, 14874, 14980, 15085,
  //       15191, 15297, 15400, 15504, 15607, 15710, 15814, 15916, 16018, 16120,
  //       16222, 16324, 16425, 16524, 16623, 16722, 16821, 16920, 17017, 17115,
  //       17212, 17309, 17406, 17500, 17594, 17688, 17782, 17875, 17968, 18060,
  //       18151, 18243, 18335, 18426, 18513, 18600, 18688, 18775, 18862, 18946,
  //       19029, 19112, 19195, 19278, 19358, 19437, 19515, 19594, 19673, 19747,
  //       19815, 19882, 19950, 20018, 20085, 20145, 20206, 20266, 20327, 20387,
  //       20440, 20492, 20543, 20595, 20647, 20692, 20732, 20773, 20813, 20853,
  //       20888, 20911, 20933, 20955, 20978, 21000,
  //     ],
  //   },
  // },

  // 17 - ТОВ "ПРIМАРIУС"
  '17p': {
    a92: {
      type: 'A-92',
      typeId: 'a92',
      tankId: 1,
      tube: 83,
      maxHeight: 185,
      maxCapacity: 10092,
      // ADD Min Capacity! ------------------------------------------------------------------------------------------------------
      minCapacity: 0,
      capacityTable: [
        0, 25, 50, 75, 100, 125, 150, 175, 200, 231, 263, 294, 333, 375, 416,
        456, 496, 537, 579, 621, 662, 704, 746, 787, 829, 871, 912, 954, 996,
        1048, 1101, 1154, 1207, 1261, 1314, 1367, 1420, 1473, 1529, 1588, 1647,
        1706, 1765, 1824, 1883, 1942, 2001, 2060, 2119, 2179, 2238, 2298, 2357,
        2417, 2476, 2539, 2604, 2669, 2734, 2799, 2864, 2929, 2994, 3058, 3123,
        3188, 3253, 3318, 3383, 3448, 3514, 3583, 3653, 3722, 3792, 3861, 3931,
        4000, 4069, 4139, 4208, 4278, 4347, 4417, 4486, 4559, 4632, 4706, 4779,
        4853, 4926, 5000, 5067, 5166, 5200, 5267, 5333, 5400, 5467, 5549, 5647,
        5720, 5786, 5857, 5915, 5959, 6019, 6089, 6160, 6224, 6287, 6363, 6432,
        6502, 6575, 6678, 6712, 6781, 6849, 6918, 6986, 7051, 7115, 7179, 7244,
        7308, 7372, 7436, 7500, 7563, 7625, 7688, 7750, 7813, 7875, 7937, 8000,
        8059, 8118, 8176, 8235, 8294, 8353, 8412, 8471, 8527, 8582, 8636, 8690,
        8745, 8799, 8853, 8908, 8962, 9014, 9060, 9106, 9153, 9199, 9245, 9292,
        9338, 9384, 9431, 9477, 9517, 9552, 9587, 9622, 9656, 9691, 9726, 9760,
        9795, 9830, 9865, 9899, 9934, 9969, 10002, 10017, 10032, 10047, 10062,
        10077, 10092,
      ],
    },
    diesel: {
      type: 'ДТ',
      typeId: 'diesel',
      tankId: 2,
      tube: 47,
      maxHeight: 174,
      maxCapacity: 9896,
      minCapacity: 238,
      capacityTable: [
        0, 20, 40, 60, 80, 100, 126, 151, 177, 203, 238, 272, 308, 348, 388,
        428, 468, 508, 548, 588, 628, 668, 708, 748, 788, 835, 884, 934, 983,
        1033, 1082, 1132, 1181, 1231, 1280, 1334, 1390, 1446, 1502, 1558, 1615,
        1671, 1727, 1783, 1840, 1898, 1955, 2013, 2070, 2128, 2185, 2243, 2300,
        2367, 2433, 2500, 2567, 2663, 2700, 2767, 2833, 2900, 2967, 3033, 3100,
        3167, 3233, 3300, 3368, 3435, 3503, 3570, 3638, 3705, 3773, 3841, 3908,
        3976, 4043, 4111, 4178, 4246, 4314, 4383, 4453, 4522, 4592, 4661, 4731,
        4800, 4872, 4945, 5017, 5090, 5162, 5235, 5307, 5377, 5448, 5518, 5589,
        5730, 5800, 5868, 5937, 6005, 6074, 6142, 6211, 6279, 6349, 6418, 6487,
        6557, 6626, 6696, 6765, 6833, 6900, 6967, 7033, 7100, 7167, 7233, 7300,
        7364, 7430, 7495, 7560, 7625, 7690, 7755, 7818, 7878, 7939, 7999, 8059,
        8119, 8180, 8240, 8300, 8357, 8415, 8472, 8530, 8587, 8645, 8702, 8760,
        8815, 8867, 8919, 8970, 9022, 9073, 9125, 9176, 9228, 9279, 9329, 9376,
        9423, 9468, 9513, 9557, 9600, 9640, 9680, 9720, 9760, 9800, 9834, 9869,
        9903, 9933, 9964, 9994,
      ],
    },
    a95: {
      type: 'А-95',
      typeId: 'a95',
      tankId: 3,
      tube: 94,
      maxHeight: 176,
      maxCapacity: 9994,
      minCapacity: 256,
      capacityTable: [
        0, 22, 43, 65, 87, 112, 141, 171, 200, 228, 256, 283, 316, 356, 395,
        435, 475, 514, 554, 594, 633, 673, 713, 752, 792, 843, 896, 949, 1002,
        1055, 1109, 1162, 1215, 1268, 1322, 1378, 1433, 1489, 1544, 1600, 1656,
        1711, 1767, 1824, 1883, 1943, 2002, 2062, 2121, 2181, 2240, 2300, 2365,
        2430, 2495, 2560, 2625, 2690, 2755, 2820, 2887, 2953, 3020, 3087, 3153,
        3220, 3287, 3354, 3422, 3489, 3557, 3624, 3692, 3759, 3828, 3899, 3969,
        4039, 4110, 4180, 4251, 4321, 4389, 4458, 4526, 4595, 4663, 4732, 4800,
        4872, 4945, 5017, 5090, 5162, 5235, 5307, 5377, 5448, 5518, 5589, 5659,
        5730, 5800, 5868, 5937, 6005, 6074, 6142, 6211, 6279, 6349, 6418, 6487,
        6557, 6626, 6696, 6765, 6833, 6900, 6967, 7033, 7100, 7167, 7233, 7300,
        7365, 7430, 7495, 7560, 7625, 7690, 7755, 7818, 7878, 7939, 7999, 8059,
        8119, 8180, 8240, 8300, 8357, 8415, 8472, 8530, 8587, 8645, 8702, 8760,
        8815, 8867, 8919, 8970, 9022, 9073, 9125, 9176, 9228, 9279, 9329, 9376,
        9423, 9468, 9513, 9557, 9600, 9640, 9680, 9720, 9760, 9800, 9834, 9869,
        9903, 9933, 9964, 9994,
      ],
    },
    a95_2: {
      type: 'А-95',
      typeId: 'a95_2',
      tankId: 4,
      tube: 83,
      maxHeight: 181,
      maxCapacity: 9982,
      minCapacity: 258,
      capacityTable: [
        0, 24, 47, 71, 94, 118, 141, 165, 188, 219, 258, 296, 330, 363, 397,
        437, 479, 522, 566, 611, 655, 699, 743, 788, 832, 876, 920, 865, 1010,
        1063, 1115, 1167, 1219, 1271, 1323, 1375, 1427, 1479, 1535, 1594, 1653,
        1712, 1771, 1829, 1888, 1947, 2006, 2069, 2131, 2194, 2256, 2319, 2381,
        2444, 2506, 2571, 2636, 2701, 2766, 2831, 2896, 2961, 3026, 3092, 3158,
        3224, 3289, 3355, 3421, 3487, 3555, 3623, 3692, 3760, 3829, 3897, 3966,
        4036, 4107, 4179, 4250, 4321, 4393, 4464, 4535, 4606, 4676, 4746, 4817,
        4887, 4958, 5027, 5096, 5164, 5233, 5301, 5370, 5438, 5507, 5577, 5648,
        5718, 5789, 5859, 5930, 6000, 6066, 6132, 6197, 6263, 6329, 6395, 6461,
        6527, 6595, 6662, 6730, 6797, 6865, 6932, 7000, 7070, 7141, 7211, 7282,
        7352, 7423, 7493, 7555, 7616, 7677, 7738, 7799, 7860, 7921, 7982, 8042,
        8102, 8163, 8223, 8283, 8343, 8404, 8464, 8521, 8574, 8628, 8681, 8734,
        8787, 8840, 8894, 8947, 9000, 9046, 9092, 9138, 9183, 9229, 9275, 9321,
        9367, 9413, 9459, 9504, 9546, 9588, 9629, 9671, 9705, 9722, 9738, 9755,
        9772, 9788, 9809, 9841, 9872, 9903, 9929, 9955, 9982,
      ],
    },
    diesel_2: {
      type: 'ДТ',
      typeId: 'diesel_2',
      tankId: 5,
      tube: 54,
      maxHeight: 179,
      maxCapacity: 10000,
      minCapacity: 234,
      capacityTable: [
        0, 20, 39, 59, 78, 98, 123, 149, 174, 200, 234, 269, 303, 337, 370, 404,
        444, 484, 526, 570, 614, 658, 702, 746, 789, 833, 877, 921, 965, 1010,
        1062, 1113, 1165, 1216, 1268, 1320, 1371, 1423, 1474, 1529, 1588, 1647,
        1706, 1765, 1824, 1882, 1941, 2000, 2059, 2118, 2176, 2235, 2294, 2353,
        2412, 2471, 2534, 2601, 2669, 2736, 2804, 2872, 2939, 3007, 3075, 3144,
        3212, 3281, 3349, 3418, 3486, 3554, 3622, 3689, 3757, 3824, 3892, 3959,
        4026, 4092, 4158, 4224, 4289, 4355, 4421, 4487, 4562, 4638, 4715, 4792,
        4869, 4946, 5019, 5083, 5147, 5212, 5276, 5340, 5404, 5468, 5536, 5609,
        5681, 5754, 5826, 5899, 5971, 6042, 6111, 6181, 6250, 6319, 6389, 6458,
        6526, 6592, 6658, 6724, 6789, 6855, 6921, 6987, 7052, 7117, 7182, 7247,
        7312, 7377, 7442, 7506, 7569, 7631, 7694, 7756, 7819, 7881, 7944, 8006,
        8064, 8122, 8180, 8238, 8297, 8355, 8413, 8471, 8527, 8582, 8637, 8692,
        8747, 8802, 8857, 8912, 8967, 9018, 9064, 9110, 9156, 9202, 9248, 9294,
        9339, 9385, 9431, 9477, 9525, 9575, 9625, 9675, 9717, 9751, 9785, 9819,
        9853, 9886, 9917, 9944, 9972, 10000,
      ],
    },
  },

  // 29 - ТОВ "ПРIМАРIУС"
  '29p': {
    a95e: {
      type: 'A-95 Energy',
      typeId: 'a95e',
      tankId: 1,
      tube: 87,
      maxHeight: 262,
      maxCapacity: 16966,
      minCapacity: 1045,
      capacityTable: [
        11, 26, 42, 61, 83, 107, 133, 161, 191, 222, 255, 289, 325, 362, 400,
        439, 480, 522, 564, 608, 653, 699, 746, 793, 842, 891, 942, 993, 1045,
        1097, 1151, 1205, 1260, 1316, 1372, 1429, 1487, 1545, 1605, 1664, 1724,
        1785, 1847, 1909, 1971, 2035, 2098, 2163, 2227, 2292, 2358, 2424, 2491,
        2558, 2626, 2694, 2763, 2832, 2901, 2971, 3041, 3112, 3183, 3254, 3326,
        3398, 3471, 3544, 3617, 3690, 3764, 3838, 3913, 3988, 4063, 4138, 4214,
        4290, 4367, 4443, 4520, 4597, 4674, 4752, 4830, 4908, 4986, 5065, 5144,
        5223, 5302, 5381, 5461, 5541, 5621, 5701, 5781, 5862, 5942, 6023, 6104,
        6185, 6266, 6348, 6429, 6511, 6593, 6675, 6757, 6839, 6921, 7003, 7086,
        7168, 7251, 7333, 7416, 7499, 7581, 7664, 7747, 7830, 7913, 7996, 8079,
        8163, 8246, 8329, 8406, 8466, 8508, 8533, 8712, 8794, 8877, 8960, 9043,
        9126, 9209, 9292, 9375, 9458, 9541, 9624, 9706, 9789, 9874, 9954, 10036,
        10118, 10201, 10283, 10365, 10446, 10528, 10610, 10691, 10772, 10854,
        10935, 11016, 11096, 11177, 11257, 11337, 11418, 11497, 11577, 11657,
        11736, 11815, 11894, 11972, 12051, 12129, 12207, 12285, 12362, 12439,
        12516, 12593, 12670, 12746, 12822, 12897, 12972, 13047, 13122, 13196,
        13270, 13344, 13417, 13490, 13563, 13635, 13707, 13779, 13850, 13921,
        13991, 14061, 14130, 14200, 14268, 14336, 14404, 14472, 14538, 14605,
        14671, 14736, 14801, 14865, 14929, 14992, 15055, 15117, 15179, 15240,
        15300, 15360, 15419, 15478, 15536, 15593, 15649, 15705, 15760, 15815,
        15868, 15921, 15973, 16024, 16075, 16124, 16173, 16221, 16268, 16314,
        16359, 16403, 16445, 16487, 16528, 16567, 16606, 16643, 16678, 16713,
        16745, 16777, 16806, 16834, 16860, 16884, 16906, 16924, 16940, 16951,
        16959, 16963, 16965, 16966,
      ],
    },

    a92: {
      type: 'А-92',
      tankId: 2,
      tube: 105,
      maxHeight: 221,
      maxCapacity: 193396,
      minCapacity: 1316,
      capacityTable: [
        20, 41, 67, 96, 129, 166, 205, 246, 290, 337, 385, 436, 488, 543, 599,
        656, 716, 777, 839, 903, 969, 1036, 1104, 1173, 1244, 1316, 1389, 1463,
        1538, 1615, 1692, 1771, 1850, 1931, 2012, 2095, 2178, 2262, 2348, 2433,
        2520, 2608, 2696, 2785, 2875, 2966, 3057, 3149, 3242, 3335, 3429, 3524,
        3619, 3715, 3812, 3909, 4007, 4105, 4204, 4303, 4403, 4503, 4604, 4705,
        4807, 4909, 5012, 5115, 5218, 5332, 5426, 5531, 5636, 5741, 5847, 5953,
        6060, 6166, 6273, 6381, 6488, 6596, 6704, 6813, 6921, 7030, 7139, 7249,
        7358, 7468, 7578, 7688, 7798, 7909, 8019, 8130, 8241, 8352, 8463, 8574,
        8685, 8797, 8908, 9020, 9131, 9243, 9354, 9466, 9578, 9690, 9801, 9913,
        10025, 10136, 10248, 10360, 10471, 10583, 10694, 10805, 10916, 11028,
        11139, 11249, 11360, 11471, 11581, 11692, 11802, 11912, 12022, 12131,
        12241, 12350, 12459, 12568, 12676, 12784, 12892, 13000, 13107, 13214,
        13321, 13428, 13534, 13640, 13745, 13850, 13955, 14060, 14164, 14267,
        14370, 14473, 14575, 14677, 14779, 14880, 14980, 15080, 15179, 15278,
        15377, 15475, 15572, 15668, 15765, 15860, 15955, 16049, 16143, 16236,
        16328, 16419, 16510, 16600, 16689, 16778, 16866, 16953, 17039, 17124,
        17208, 17292, 17375, 17456, 17537, 17617, 17695, 17773, 17850, 17925,
        18000, 18073, 18145, 18216, 18286, 18354, 18421, 18487, 18551, 18614,
        18675, 18734, 18792, 18849, 18903, 18956, 19007, 19055, 19102, 19146,
        19188, 19227, 19264, 19297, 19327, 19352, 19373, 19386, 19394, 19396,
      ],
    },

    a95: {
      type: 'А-95',
      typeId: 'a95',
      tankId: 3,
      tube: 124,
      maxHeight: 222,
      maxCapacity: 19254,
      minCapacity: 1329,
      capacityTable: [
        1, 5, 19, 40, 66, 96, 130, 166, 206, 248, 293, 340, 389, 440, 493, 548,
        605, 663, 724, 785, 848, 913, 979, 1047, 1115, 1185, 1257, 1329, 1403,
        1478, 1554, 1631, 1709, 1788, 1868, 1949, 2031, 2114, 2198, 2283, 2369,
        2455, 2545, 2631, 2719, 2809, 2900, 2991, 3083, 3175, 3268, 3362, 3457,
        3552, 3648, 3744, 3841, 3939, 4037, 4136, 4235, 4334, 4435, 4535, 4637,
        4738, 4841, 4943, 5046, 5150, 5253, 5358, 5462, 5567, 5672, 5778, 5884,
        5991, 6097, 6204, 6312, 6419, 6527, 6635, 6743, 6852, 6961, 7070, 7179,
        7289, 7399, 7509, 7619, 7729, 7839, 7950, 8060, 8171, 8282, 8393, 8504,
        8615, 8727, 8838, 8950, 9061, 9173, 9284, 9396, 9507, 9619, 9731, 9842,
        9954, 10065, 10177, 10288, 10400, 10511, 10622, 10733, 10845, 10956,
        11066, 11177, 11288, 11398, 11509, 11619, 11729, 11838, 11948, 12057,
        12167, 12276, 12384, 12493, 12601, 12709, 12817, 12924, 13032, 13138,
        13245, 13351, 13457, 13563, 13668, 13773, 13877, 13981, 14085, 14188,
        14291, 14394, 14495, 14597, 14698, 14799, 14899, 14998, 15097, 15196,
        15294, 15391, 15488, 15584, 15680, 15775, 15870, 15963, 16056, 16149,
        16241, 16332, 16422, 16512, 16600, 16688, 16776, 16862, 16948, 17032,
        17116, 17199, 17281, 17362, 17442, 17521, 17599, 17676, 17752, 17827,
        17901, 17973, 18045, 18115, 18184, 18251, 18317, 18382, 18446, 18507,
        18568, 18626, 18683, 18739, 18792, 18844, 18893, 18941, 18986, 19029,
        19069, 19107, 19141, 19172, 19200, 19223, 19239, 19249, 19253, 19254,
      ],
    },

    diesel: {
      type: 'ДТ',
      tankId: 4,
      tube: 142,
      maxHeight: 220,
      maxCapacity: 19308,
      minCapacity: 1356,
      capacityTable: [
        11, 28, 51, 79, 110, 145, 183, 223, 266, 312, 359, 409, 461, 515, 570,
        627, 686, 747, 809, 873, 938, 1004, 1072, 1141, 1212, 1283, 1356, 1430,
        1505, 1581, 1659, 1737, 1817, 1897, 1978, 2061, 2144, 2228, 2313, 2399,
        2486, 2573, 2662, 2751, 2841, 2931, 3023, 3115, 3208, 3301, 3395, 3490,
        3585, 3681, 3778, 3875, 3973, 4071, 4170, 4269, 4369, 4469, 4570, 4672,
        4773, 4876, 4978, 5082, 5185, 5289, 5393, 5498, 5603, 5709, 5815, 5921,
        6027, 6134, 6241, 6349, 6456, 6564, 6673, 6781, 6890, 6999, 7108, 7217,
        7327, 7437, 7547, 7657, 7767, 7878, 7989, 8099, 8217, 8321, 8433, 8544,
        8655, 8767, 8878, 8990, 9101, 9213, 9325, 9436, 9548, 9660, 9772, 9883,
        9995, 10107, 10218, 10330, 10441, 10553, 10664, 10776, 10887, 10998,
        11109, 11220, 11330, 11441, 11552, 11662, 11772, 11882, 11992, 12101,
        12210, 12320, 12428, 12537, 12646, 12754, 12862, 12969, 13076, 13183,
        13290, 13397, 13503, 13608, 13714, 13819, 13923, 14027, 14131, 14235,
        14338, 14440, 14542, 14644, 14745, 14846, 14946, 15046, 15145, 15244,
        15342, 15439, 15536, 15633, 15729, 15824, 15918, 16012, 16106, 16198,
        16290, 16381, 16472, 16561, 16650, 16738, 16826, 16912, 16998, 17083,
        17167, 17250, 17332, 17413, 17493, 17573, 17651, 17728, 17804, 17879,
        17953, 18025, 18097, 18167, 18236, 18304, 18370, 18435, 18498, 18560,
        18621, 18680, 18737, 18792, 18846, 18897, 18947, 18995, 19040, 19083,
        19123, 19161, 19196, 19228, 19255, 19279, 19297, 19307, 19308,
      ],
    },
  },
  // 28 - ТОВ "АЛЕТЕЯ"
  '28a': {
    a95: {
      type: 'A-95',
      typeId: 'a95',
      tankId: 1,
      tube: 145,
      maxHeight: 2760,
      maxCapacity: 20598,
      minCapacity: 928,
      capacityTable: [
        4, 18, 37, 60, 87, 116, 148, 183, 220, 260, 301, 344, 390, 437, 485,
        535, 587, 640, 695, 751, 809, 868, 928, 989, 1052, 1115, 1180, 1246,
        1314, 1382, 1451, 1521, 1592, 1665, 1738, 1812, 1887, 1963, 2040, 2118,
        2196, 2275, 2356, 2437, 2518, 2601, 2684, 2768, 2853, 2938, 3024, 3111,
        3199, 3287, 3376, 3465, 3555, 3646, 3737, 3829, 3921, 4014, 4108, 4202,
        4296, 4391, 4487, 4583, 4680, 4777, 4875, 4973, 5071, 5170, 5269, 5369,
        5469, 5570, 5671, 5772, 5874, 5976, 6079, 6182, 6285, 6389, 6492, 6597,
        6701, 6806, 6911, 7016, 7122, 7228, 7334, 7440, 7547, 7654, 7761, 7868,
        7976, 8084, 8192, 8300, 8408, 8516, 8625, 8734, 8842, 8951, 9060, 9170,
        9278, 9388, 9498, 9607, 9717, 9827, 9936, 10046, 10156, 10266, 10375,
        10485, 10595, 10705, 10814, 10924, 11034, 11143, 11253, 11362, 11471,
        11580, 11689, 11798, 11907, 12016, 12124, 12233, 12341, 12449, 12557,
        12664, 12772, 12879, 12986, 13093, 13199, 13306, 13412, 13518, 13623,
        13729, 13834, 13938, 14043, 14147, 14251, 14354, 14457, 14560, 14662,
        14764, 14866, 14967, 15068, 15169, 15269, 15369, 15468, 15567, 15665,
        15763, 15860, 15957, 16054, 16150, 16246, 16341, 16435, 16529, 16622,
        16715, 16807, 16899, 16990, 17081, 17171, 17260, 17349, 17437, 17524,
        17611, 17696, 17782, 17866, 17950, 18033, 18115, 18197, 18278, 18358,
        18437, 18515, 18593, 18669, 18745, 18820, 18894, 18966, 19038, 19109,
        19179, 19248, 19316, 19383, 19448, 19513, 19576, 19638, 19699, 19759,
        19817, 19874, 19930, 19984, 20037, 20088, 20138, 20185, 20232, 20276,
        20318, 20359, 20397, 20433, 20467, 20498, 20526, 20551, 20572, 20588,
        20598,
      ],
    },

    a92: {
      type: 'A-92',
      typeId: 'a92',
      tankId: 2,
      tube: 520,
      maxHeight: 2490,
      maxCapacity: 21052,
      minCapacity: 952,
      capacityTable: [
        6, 14, 28, 48, 71, 99, 129, 162, 198, 236, 276, 318, 362, 408, 455, 504,
        555, 608, 661, 717, 773, 831, 891, 952, 1013, 1077, 1141, 1206, 1273,
        1340, 1409, 1479, 1550, 1622, 1694, 1768, 1843, 1918, 1995, 2072, 2150,
        2229, 2309, 2390, 2471, 2553, 2636, 2720, 2805, 2890, 2976, 3062, 3150,
        3238, 3326, 3415, 3505, 3596, 3687, 3779, 3871, 3964, 4057, 4151, 4246,
        4341, 4437, 4533, 4629, 4727, 4824, 4922, 5021, 5120, 5219, 5319, 5419,
        5520, 5621, 5723, 5825, 5927, 6030, 6133, 6236, 6340, 6444, 6548, 6653,
        6758, 6864, 6969, 7075, 7181, 7288, 7395, 7502, 7609, 7716, 7824, 7932,
        8040, 8148, 8257, 8366, 8475, 8584, 8693, 8802, 8911, 9021, 9131, 9241,
        9351, 9461, 9571, 9682, 9792, 9902, 10013, 10123, 10234, 10345, 10455,
        10566, 10677, 10787, 10898, 11008, 11119, 11229, 11340, 11450, 11560,
        11670, 11780, 11890, 12000, 12110, 12220, 12329, 12438, 12547, 12656,
        12765, 12874, 12982, 13090, 13198, 13306, 13414, 13521, 13628, 13735,
        13841, 13948, 14054, 14159, 14265, 14370, 14475, 14579, 14683, 14787,
        14891, 14994, 15097, 15199, 15301, 15403, 15504, 15605, 15705, 15805,
        15905, 16004, 16103, 16201, 16299, 16396, 16493, 16589, 16685, 16780,
        16875, 16969, 17062, 17155, 17248, 17340, 17431, 17522, 17612, 17701,
        17790, 17878, 17966, 18052, 18138, 18224, 18309, 18392, 18476, 18558,
        18640, 18721, 18801, 18880, 18958, 19036, 19113, 19188, 19263, 19337,
        19410, 19482, 19553, 19623, 19692, 19760, 19827, 19893, 19958, 20021,
        20083, 20144, 20204, 20262, 20319, 20375, 20429, 20482, 20534, 20583,
        20631, 20678, 20722, 20765, 20805, 20844, 20880, 20914, 20945, 20973,
        20998, 21018, 21034, 21044, 21050, 21052,
      ],
    },

    a95_2: {
      type: 'A-95',
      typeId: 'a95_2',
      tankId: 3,
      tube: 520,
      maxHeight: 2770,
      maxCapacity: 21046,
      minCapacity: 948,
      capacityTable: [
        10, 24, 44, 69, 96, 126, 160, 195, 233, 273, 315, 359, 405, 452, 501,
        552, 604, 658, 713, 770, 828, 887, 948, 1010, 1073, 1137, 1202, 1269,
        1336, 1405, 1475, 1545, 1617, 1690, 1763, 1838, 1913, 1990, 2067, 2145,
        2224, 2304, 2384, 2466, 2548, 2631, 2714, 2799, 2884, 2970, 3056, 3143,
        3231, 3320, 3409, 3499, 3589, 3680, 3772, 3864, 3957, 4050, 4144, 4239,
        4334, 4429, 4525, 4622, 4719, 4817, 4915, 5013, 5112, 5211, 5311, 5411,
        5512, 5613, 5715, 5816, 5919, 6021, 6124, 6228, 6331, 6435, 6540, 6644,
        6749, 6855, 6960, 7066, 7172, 7279, 7385, 7492, 7599, 7707, 7814, 7922,
        8030, 8139, 8247, 8356, 8465, 8574, 8683, 8792, 8902, 9011, 9121, 9230,
        9340, 9450, 9561, 9671, 9781, 9892, 10002, 10113, 10223, 10334, 10444,
        10555, 10666, 10776, 10887, 10997, 11108, 11218, 11329, 11439, 11549,
        11659, 11769, 11879, 11989, 12098, 12208, 12318, 12427, 12536, 12645,
        12753, 12862, 12970, 13079, 13186, 13294, 13402, 13509, 13616, 13723,
        13829, 13936, 14042, 14147, 14253, 14358, 14463, 14567, 14671, 14775,
        14879, 14982, 15085, 15187, 15289, 15391, 15492, 15593, 15693, 15793,
        15893, 15992, 16091, 16189, 16286, 16384, 16480, 16577, 16673, 16768,
        16862, 16957, 17050, 17143, 17236, 17328, 17419, 17510, 17600, 17689,
        17778, 17866, 17954, 18041, 18127, 18212, 18297, 18381, 18464, 18547,
        18628, 18709, 18789, 18869, 18947, 19025, 19101, 19177, 19252, 19326,
        19399, 19471, 19543, 19613, 19682, 19750, 19817, 19883, 19947, 20011,
        20073, 20134, 20194, 20253, 20310, 20366, 20420, 20473, 20525, 20574,
        20623, 20669, 20714, 20757, 20798, 20836, 20873, 20907, 20939, 20967,
        20993, 21015, 21032, 21044, 21046,
      ],
    },

    diesel: {
      type: 'ДП',
      typeId: 'diesel',
      tankId: 4,
      tube: 100,
      maxHeight: 2460,
      maxCapacity: 20887,
      minCapacity: 1042,
      capacityTable: [
        16, 35, 57, 89, 112, 144, 179, 216, 255, 296, 339, 384, 430, 478, 528,
        580, 633, 687, 743, 800, 859, 919, 980, 1042, 1105, 1170, 1236, 1302,
        1370, 1439, 1509, 1580, 1652, 1725, 1799, 1874, 1949, 2026, 2103, 2181,
        2260, 2340, 2421, 2502, 2585, 2668, 2751, 2836, 2921, 3007, 3093, 3180,
        3268, 3357, 3446, 3536, 3626, 3717, 3809, 3901, 3993, 4087, 4180, 4275,
        4370, 4465, 4561, 4657, 4754, 4851, 4949, 5048, 5146, 5245, 5345, 5445,
        5545, 5646, 5747, 5849, 5951, 6053, 6156, 6259, 6362, 6466, 6570, 6674,
        6779, 6884, 6989, 7095, 7200, 7306, 7413, 7519, 7626, 7733, 7840, 7948,
        8055, 8163, 8271, 8379, 8488, 8596, 8705, 8814, 8923, 9032, 9141, 9250,
        9360, 9469, 9579, 9689, 9798, 9908, 10018, 10128, 10238, 10348, 10458,
        10568, 10678, 10788, 10898, 11008, 11118, 11227, 11337, 11447, 11556,
        11666, 11775, 11884, 11993, 12102, 12211, 12320, 12428, 12537, 12645,
        12753, 12860, 12968, 13075, 13183, 13290, 13396, 13503, 13609, 13715,
        13821, 13926, 14031, 14136, 14241, 14345, 14449, 14553, 14656, 14759,
        14861, 14964, 15065, 15167, 15268, 15369, 15469, 15569, 15668, 15767,
        15866, 15964, 16062, 16159, 16256, 16352, 16448, 16543, 16638, 16732,
        16826, 16919, 17011, 17103, 17195, 17286, 17376, 17465, 17554, 17643,
        17731, 17818, 17901, 17990, 18075, 18159, 18242, 18325, 18407, 18488,
        18569, 18649, 18727, 18805, 18883, 18959, 19034, 19109, 19182, 19255,
        19327, 19397, 19467, 19536, 19603, 19670, 19735, 19800, 19863, 19925,
        19985, 20045, 20103, 20160, 20215, 20269, 20322, 20373, 20423, 20470,
        20517, 20561, 20603, 20644, 20682, 20718, 20752, 20783, 20812, 20837,
        20858, 20875, 20886, 20887,
      ],
    },
  },
};

// const test = (gs, table) => {
//   console.log(`Current length - ${tables[gs][table].capacityTable.length - 1}`);

//   let cur = 0;
//   tables[gs][table].capacityTable.forEach((element, index) => {
//     if (element > cur) {
//       cur = element;
//     } else {
//       console.log(`Error at ${index}: ${element}`);
//       return;
//     }
//   });
//   console.log('Test finished!');
// };

// test('29p', 'diesel');
export default tables;
